// extracted by mini-css-extract-plugin
export var active = "HoverCards-module--active--18e83";
export var activeDot = "HoverCards-module--activeDot--5f037";
export var cardContent = "HoverCards-module--cardContent--3b10e";
export var cardContentAlt = "HoverCards-module--cardContentAlt--a0030";
export var cardImg = "HoverCards-module--cardImg--962f9";
export var cardImgAlt = "HoverCards-module--cardImgAlt--8efb0";
export var cardImgBg = "HoverCards-module--cardImgBg--740ae";
export var comingSoonBadge = "HoverCards-module--comingSoonBadge--6810a";
export var container = "HoverCards-module--container--9b216";
export var containerAlt = "HoverCards-module--containerAlt--e2434";
export var grid = "HoverCards-module--grid--27d5f";
export var gridAlt = "HoverCards-module--gridAlt--b941a";
export var mobileCard = "HoverCards-module--mobileCard--d7a39";
export var mobileCards = "HoverCards-module--mobileCards--a5e62";
export var paragraph = "HoverCards-module--paragraph--96410";
export var paragraphSm = "HoverCards-module--paragraph-sm--229f8";
export var paragraphXs = "HoverCards-module--paragraph-xs--9f8c0";
export var titleH1 = "HoverCards-module--title-h1--fb77c";
export var titleH1Alt = "HoverCards-module--title-h1--alt--c4e83";
export var titleH2 = "HoverCards-module--title-h2--77f22";
export var titleH2Alt = "HoverCards-module--title-h2--alt--13838";
export var titleH3 = "HoverCards-module--title-h3--eb9f3";
export var titleH3Alt = "HoverCards-module--title-h3--alt--375ea";
export var titleH4 = "HoverCards-module--title-h4--702a8";
export var titleH4Alt = "HoverCards-module--title-h4--alt--f8018";
export var titleH5 = "HoverCards-module--title-h5--074fe";
export var visible = "HoverCards-module--visible--e86ea";